import { Dropdown } from '@sqs/rosetta-compositions';
import { Text } from '@sqs/rosetta-primitives';
import { useTheme } from '@sqs/rosetta-styled';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useGetSqspUserRoleMap } from '../../hooks/useGetSqspUserRoleMap';
import { useI18n } from '../../i18n';
import { Banner } from '@sqs/rosetta-compositions/banner/next';

import { ORG_MEMBER, ORG_MANAGER, SqspUserType } from '../../models/SqspUser';

interface UserRoleDropdownProps {
  readonly currentRole?: SqspUserType;
}

export const UserRoleDropdown = ({ currentRole }: UserRoleDropdownProps) => {
  const { fontSizes } = useTheme();
  const { T, t } = useI18n();
  const { getUserRole } = useGetSqspUserRoleMap();
  const {
    clearErrors,
    formState: { errors },
    register,
    setValue,
    watch
  } = useFormContext<{[x: string]: string;}>();

  const userRole = watch('orgRole');
  register('orgRole', { required: t("Please choose a role for this user", {}, { project: 'enterprise-dashboard' }) });

  return (
    <>
      <Dropdown
        id="user-role"
        aria-labelledby="role-text"
        placement="bottom"
        onChange={(val: string) => {
          setValue('orgRole', val, { shouldDirty: true });
          clearErrors('orgRole');
        }}
        value={watch('orgRole')}>

        <Dropdown.Option
          value={ORG_MEMBER}
          description={
          <Text.Caption>
              <T project="enterprise-dashboard">{"Org members have limited access to the organization. They can be added to any scheduling instances with unique permission levels."}</T>



            </Text.Caption>
          }>

          <Text.Body m={0} fontSize={fontSizes[3]} fontWeight={500}>
            {getUserRole(ORG_MEMBER)}
          </Text.Body>
        </Dropdown.Option>
        <Dropdown.Option
          value={ORG_MANAGER}
          description={
          <Text.Caption>
              <T project="enterprise-dashboard">{"Managers have full access to the organization, which includes all scheduling instances, user management, and organization wide settings."}</T>



            </Text.Caption>
          }>

          <Text.Body m={0} fontSize={fontSizes[3]} fontWeight={500}>
            {getUserRole(ORG_MANAGER)}
          </Text.Body>
        </Dropdown.Option>
      </Dropdown>
      {errors.orgRole &&
      <Text.Label color="red.400" role="alert">
          {errors.orgRole.message}
        </Text.Label>
      }
      {currentRole === ORG_MEMBER && userRole === ORG_MANAGER &&
      <Banner.Info mt={5}>
          <Banner.Info.Main>
            <Banner.Info.Row>
              <Banner.Info.Column>
                <Banner.Info.Title>
                  <T project="enterprise-dashboard">{"You are making this user a Manager"}</T>
                </Banner.Info.Title>
                <Banner.Info.Body>
                  <T project="enterprise-dashboard">{"Org managers have access to all scheduling instances and management settings for the organization."}</T>


                </Banner.Info.Body>
              </Banner.Info.Column>
            </Banner.Info.Row>
          </Banner.Info.Main>
        </Banner.Info>
      }
      {currentRole === ORG_MANAGER && userRole === ORG_MEMBER &&
      <Banner.Info mt={5}>
          <Banner.Info.Main>
            <Banner.Info.Row>
              <Banner.Info.Column>
                <Banner.Info.Title>
                  <T project="enterprise-dashboard">{"You are changing this user from a Manager"}</T>
                </Banner.Info.Title>
                <Banner.Info.Body>
                  <T project="enterprise-dashboard">{"This user will lose access to their current scheduling instances."}</T>


                </Banner.Info.Body>
              </Banner.Info.Column>
            </Banner.Info.Row>
          </Banner.Info.Main>
        </Banner.Info>
      }
    </>);

};